
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'LoaderOverlay',

  props: {
    isLoading: {
      type: Boolean,
      default: true
    },

    showLoadingText: {
      type: Boolean,
      default: false
    },

    hasCursorWait: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      faSpinnerThird
    }
  }
}
